import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import useMailboxService from 'src/modules/mailer/hooks/useMailboxService';
import useMailerDriver from 'src/modules/mailer/hooks/useMailerDriver';
import { normalizeMailboxMessage, mapMailboxActionError } from '../../../helpers';

export const MAILBOX_MESSAGE_QUERY_KEY = 'mailbox-fetch-message';

const useMailboxMessage = ({
    t,
    messageId,
}) => {
    const service = useMailboxService();
    const { active } = useMailerDriver();
    const query = useQuery({
        queryKey: [MAILBOX_MESSAGE_QUERY_KEY, active, messageId],
        queryFn: async () => {
            const payload = await service.fetchMessage(messageId);

            return normalizeMailboxMessage(payload);
        },
        enabled: !!messageId,
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            if (error?.response?.status === 404) {
                return;
            }

            toast.error(mapMailboxActionError(
                error,
                t,
                'An error occurred while fetching the mailbox message.'
            ));
        },
    });

    return {
        message: query.data || null,
        isLoading: query.isLoading,
        isFetching: query.isFetching,
        isError: query.isError,
        isNotFound: query.isError && query.error?.response?.status === 404,
        refetch: query.refetch,
    };
};

export default useMailboxMessage;
